import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { postRequest } from '~services';
import {
  BaseQueryRequest,
  NewQueryResponse,
  SORT_TYPE,
  UnassignedStation,
  UseQueryOptionsType,
} from '~types';

export type StationSortField = {
  imei: SORT_TYPE;
};

export type StationFilterField = {
  imeis: string[];
};

type StationRequest = BaseQueryRequest<StationSortField, StationFilterField> & {
  search: string;
  managedGroupId?: string | null;
};
type StationsResponse = NewQueryResponse<UnassignedStation>;

export const useQueryListUnassignedStation = (
  reqParams: StationRequest,
  options?: UseQueryOptionsType<StationRequest, StationsResponse>,
) => {
  const getStations = (): Promise<StationsResponse> =>
    postRequest({
      path: 'api/station/list-with-unassigned-stations',
      data: reqParams,
    }).then((res) => res.data);

  return useQuery(
    [QUERY_KEY.GET_LIST_UNASSIGNED_STATION, reqParams],
    () => getStations(),
    { ...options },
  );
};
